export default commomImport => [{
  path: `add-product`,
  name: 'add',
  hidden: true,
  meta: {
    title: '新增商品',
    noCache: true
  },
  //  全部订单
  component: commomImport('product-manager/product-list/add')
}];
